import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { energyWorkCopy, energyWorkSources } from './energyWorkArticleContent';

export const EnergyWorkArticle = () => {
  const { language } = useLanguage();
  const lang = language === 'es' ? 'es' : 'en';
  const c = energyWorkCopy[lang];

  useEffect(() => {
    const previousTitle = document.title;
    const description = document.querySelector('meta[name="description"]');
    const previousDescription = description?.getAttribute('content');
    document.title = `${c.title} | ABBA Massage`;
    description?.setAttribute('content', c.summary);
    return () => {
      document.title = previousTitle;
      if (previousDescription !== null && previousDescription !== undefined) {
        description?.setAttribute('content', previousDescription);
      }
    };
  }, [c]);

  return (
    <main className="min-h-screen bg-[#F8F6F3] pt-32 pb-24 px-6" data-testid="energy-work-article" lang={lang}>
      <article className="max-w-3xl mx-auto">
        <Link to="/articles" className="inline-flex items-center gap-2 text-[#A91B60] font-['Manrope'] font-semibold mb-10">
          <ArrowLeft size={18} />{lang === 'es' ? 'Todos los artículos' : 'All articles'}
        </Link>
        <p className="text-[#A91B60] uppercase tracking-[0.2em] text-sm font-semibold mb-4">
          ABBA Massage · {lang === 'es' ? 'Artículos' : 'Articles'}
        </p>
        <h1 className="font-['Playfair_Display'] text-4xl md:text-5xl text-[#1C1C1C] leading-tight mb-8">{c.title}</h1>
        <div className="space-y-7 font-['Manrope'] text-lg leading-relaxed text-[#414141]">
          <p className="text-xl">{c.lead}</p>
          {c.sections.map((section, index) => (
            <section key={section.title} className="space-y-5" data-testid={`energy-article-section-${index}`}>
              <h2 className="font-['Playfair_Display'] text-3xl text-[#1C1C1C] pt-4">{section.title}</h2>
              {section.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
              {Number.isInteger(section.source) && (
                <a href={energyWorkSources[section.source].url} target="_blank" rel="noopener noreferrer" className="inline-block text-sm text-[#A91B60] underline">
                  {c.sourceLabel} [{section.source + 1}]
                </a>
              )}
            </section>
          ))}
          <p className="border-l-4 border-[#75445F] pl-6 font-['Playfair_Display'] italic text-2xl text-[#75445F]">{c.closing}</p>
          <Link to="/energy-work#bioenergy-healing-massage" className="inline-flex items-center gap-2 text-[#A91B60] font-semibold underline">
            {lang === 'es' ? 'Descubre Bioenergy Healing Massage: individual o en pareja' : 'Discover Bioenergy Healing Massage: individually or for couples'}<ArrowRight size={18} />
          </Link>
          <a href="https://wa.me/message/AIKG7VFJUUNMJ1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#A91B60] hover:bg-[#8A1650] px-7 py-4 text-white font-semibold">
            {c.cta}<ArrowRight size={18} />
          </a>
          <section className="border-t border-[#A91B60]/20 pt-7">
            <h2 className="font-['Playfair_Display'] text-2xl mb-5">{c.sourcesLabel}</h2>
            <ol className="list-decimal pl-6 space-y-3 text-sm">
              {energyWorkSources.map((source) => (
                <li key={source.url}><a href={source.url} target="_blank" rel="noopener noreferrer" className="text-[#A91B60] underline">{source.title}</a></li>
              ))}
            </ol>
          </section>
        </div>
      </article>
    </main>
  );
};

export default EnergyWorkArticle;
